//import Libraries
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {storageRef} from '../../../../firebase';

//import Components
import SliderType from './HiddenContent/SliderType';
import NormalType from './HiddenContent/NormalType';
import CardsType from './HiddenContent/CardsType';

//import Style classes
import './PromotionCard.css'

class PromotionCard extends Component{

    constructor(props) {
        super(props);
        this.state = {
            url : '',
            urls : [],
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.data.id !== this.props.data.id) {
            this.loadImageFromStorage();
        }
    }

    componentDidMount(){
        this.loadImageFromStorage()
    }

    loadImageFromStorage = () => {
        const imageCount = this.props.data.count ? this.props.data.count : 0;
        this.setState({
            url : '',
            urls : new Array(imageCount) 
        })

        storageRef.child(`${this.props.storagePath}/${this.props.data.id}.jpg`).getDownloadURL()
            .then((url) => {
                this.setState((prevState) => ({
                    url,
                }))
            })
            .catch(e => {
            })
        if(imageCount && imageCount > 0) {
            for(let i = 0; i < imageCount; ++i) {
                storageRef.child(`${this.props.storagePath}/${this.props.data.id}_${i}.jpg`).getDownloadURL()
                    .then((url) => {
                        let urlsCopy = [...this.state.urls];
                        urlsCopy[i] = url;
                        this.setState((prevState) => ({
                            urls : urlsCopy
                        }))
                    })
                    .catch(e => {
                    })
            }
        }
    }

    render() {
        let addBoxClass = "";
        let animationStyleIndex = this.props.index % 3 + 1;

        let addCardClass = this.props.data.type+" index"+animationStyleIndex+" open";

        let hiddenContent;
        switch (this.props.data.type) {
            case "normal":
                hiddenContent = 
                    <NormalType data={this.props.data} lang={this.props.lang}/>
                break;
            case "slider":
                hiddenContent =
                    <SliderType data={this.props.data} urls={this.state.urls} lang={this.props.lang}/>
                break;
            case "cards":
                hiddenContent =
                    <CardsType data={this.props.data} urls={this.state.urls} lang={this.props.lang}/>
                break;
            default:
                break;
        } 

        return(
            <div id={this.props.data.id} className={"ContentCardBox open Promotion"+addBoxClass}>
                <div className={"ContentCard "+addCardClass}>
                    <div className="ContentImage">
                        <div className="ColorOverride"></div>
                        <img src={this.state.url}/>
                    </div> 
                    {hiddenContent}
                    <div className="PromoTag"><h4>{{"en":"Promotion", "ko": "프로모션중"}[this.props.lang]}</h4></div>
                </div>
            </div>
        )
    }
}

export default PromotionCard;

PromotionCard.propTypes = {
    data: PropTypes.object.isRequired
  };



// WEBPACK FOOTER //
// ./src/components/DepartmentModule/Contents/ContentCard/PromotionCard.js